
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import Input from '@/components/Core/Input.vue';

  import accountService from '@/services/account.service';
  import { IValidateAccessKeyModel } from '@/models/account.model';

  @Component({
    components: {
      Input,
    },
    computed: {
      ...mapGetters([
        'redirectUrl'
      ])
    }
  })
  export default class AccessKey extends Vue {
    data() {
      return {
        studio: '',
        registerUrl: '',
        isValidateKeyLoading: false,
        key: '',
        hasErrors: false,
        errors: []
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;

      if (this.$store.getters.redirectUrl != null && this.$store.getters.redirectUrl != '') {
        this.$data.registerUrl = { name: 'Register', query: { 'redirectUrl': this.$store.getters.redirectUrl } };
      }
      else {
        this.$data.registerUrl = { name: 'Register' };
      }
    }

    updateKeyValue(parameterName: string, value: string) {
      this.$data.key = value;
    }

    validateKey() {
      setTimeout(() => {
        this.$data.isValidateKeyLoading = true;
        const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "accesskey/validate";
        accountService.post<IValidateAccessKeyModel, object>(this, url, { Value: this.$data.key })
          .then(() => {
            this.$store.dispatch('updateAccessKey', this.$data.key);
            this.goToRegister();
            this.$data.isValidateKeyLoading = false;
          })
          .catch(error => {
            this.$data.hasErrors = true;
            this.$data.errors = error.data.ErrorMessages;
            this.$data.isValidateKeyLoading = false;
            this.$store.dispatch("updateIsLoading", false);
          });
      }, 300);
    }

    goToRegister() {
      this.$router.push(this.$data.registerUrl);
    }
  }
